var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SlotSwitcher',{attrs:{"active-index":_vm.getSlotSwitcherIndex,"global":"","loading":_vm.loading},on:{"toggle":_vm.toggle}},[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }